<template>
	<div 
		class="button-container"
		:class="[
			fullWidth ? `full-width` : ''
		]"
		>

		<Link 
			:href="buttonRoute" 
			v-if="buttonRoute"
			:class="[
				fullWidth ? `full-width` : ''
			]"
			>
			<div 
				class="button"
				:class="[
					`color-${color}`,
					`size-${size}`,
					`push-${push}`,
					`${disabled ? 'disabled' : ''}`,
					!label || label.length == 0 ? 'no-label' : '',
					forceHeight ? `force-height` : '',
					fullWidth ? `full-width` : '',
					!icon ? 'no-icon' : ''
				]"
				>
				<div class="label" v-if="label">
					{{ label }}
				</div>

				<div 
					v-if="icon"	
					class="icon"
					>
					<i 
						class="fal"
						:class="[`fa-${icon}`]"
						/>
				</div>
			</div>
		</Link>

		<div 
			v-else
			class="button"
			:class="[
				`color-${color}`,
				`size-${size}`,
				`push-${push}`,
				`${disabled ? 'disabled' : ''}`,
				!label || label.length == 0 ? 'no-label' : '',
				forceHeight ? `force-height` : '',
				fullWidth ? `full-width` : '',
					!icon ? 'no-icon' : ''
			]"
			>
			<div class="label" v-if="label">
				{{ label }}
			</div>

			<div 
				v-if="icon"	
				class="icon"
				>
				<i 
					class="fal"
					:class="[`fa-${icon}`]"
					/>
			</div>
		</div>

	</div>
</template>

<script>

import { Link } from '@inertiajs/inertia-vue3'

export default {
	components: {
		Link
	},
	props: {
		label: {
			type: String,
			required: true
		},
		color: {
			type: String,
			required: false,
			default: 'green'
		},
		size: {
			type: String,
			required: false,
			default: 'regular'
		},
		icon: {
			type: String,
			required: false,
			default: false
		},
		buttonRoute: {
			type: String,
			default: null
		},
		disabled: {
			type: Boolean,
			default: false
		},
		push: {
			type: String,
			default: null
		},
		forceHeight: {
			type: Boolean,
			default: false
		},
		fullWidth: {
			type: Boolean,
			default: false
		}
	}
}
</script>

<style lang="sass">

$small-height: 30px
$regular-height: 40px
$large-height: 50px

.button-container
	display: inline-flex

	&.full-width
		width: 100%
		display: flex

	a
		&.full-width
			width: 100%
			display: flex

	.button
		box-shadow: 0 2px 9px rgba(#000, 0.1)
		min-height: $regular-height
		display: inline-grid
		border-radius: 6px
		overflow: hidden
		align-items: center
		transition: all 300ms
		width: auto
		cursor: pointer
		user-select: none
		grid-template-columns: 1fr 50px

		&.disabled
			opacity: 0.4
			cursor: not-allowed

		.label
			padding: 0 20px
			font-weight: 700
			font-size: 16px
			font-family: 'Roboto', sans-serif
			display: flex
			align-items: center
			min-height: $regular-height
			height: 100%
			text-transform: capitalize
			// white-space: nowrap
			text-align: center
			justify-content: center

			@media (max-width: 768px)
				font-size: 14px

		.icon
			height: 100%
			border-left-width: 1px
			border-right-style: solid
			border-left-color: #e9e9e9
			min-height: $regular-height
			display: flex
			align-items: center
			justify-content: center
			font-size: 16px

		&.color-blue
			background-color: #70C2FF
			border: 1px solid #70C2FF

			&:hover
				background-color: lighten(#70C2FF, 3%)

			.label
				color: #fff

			.icon
				color: #fff

		&.color-black
			background-color: #111
			border: 1px solid #111

			&:hover
				background-color: #333

			.label
				color: #fff

			.icon
				color: #fff

		&.color-red
			background-color: darken(#f00, 20%)
			border: 1px solid darken(#f00, 20%)

			&:hover
				background-color: lighten(darken(#f00, 20%), 3%)

			.label
				color: #fff

			.icon
				color: #fff

		&.color-yellow
			background-color: #ffcc00
			border: 1px solid #ffcc00

			&:hover
				background-color: #ff9000

			.label
				color: #111

			.icon
				color: #111

		&.color-green
			background-color: #5AAE4B
			border: 1px solid #5AAE4B

			&:hover
				background-color: lighten(#5AAE4B, 10%)

			.label
				color: #fff

			.icon
				color: #fff

		&.color-white
			background-color: #fff
			border: 1px solid #e9e9e9

			&:hover
				background-color: #f8f8f8

			.label
				color: #252525
			
			.icon
				color: #252525

		&.color-dark
			background-color: #252525
			border: 1px solid #252525

			&:hover
				background-color: lighten(#252525, 10%)

			.label
				color: #fff
			
			.icon
				color: #fff

		&.size-small
			min-height: $small-height
			grid-template-columns: 1fr $small-height

			&.force-height
				height: $small-height

				.label
					height: $small-height

				.icon
					height: $small-height

			.label
				min-height: $small-height
				padding: 0 15px
				font-size: 14px

			.icon
				min-height: $small-height
				width: $small-height

		&.size-regular
			min-height: $regular-height
			grid-template-columns: 1fr $regular-height

			&.force-height
				height: $regular-height

				.label
					height: $regular-height

				.icon
					height: $regular-height

			.icon
				min-height: $regular-height
				width: $regular-height
				font-size: 18px

		&.size-large
			min-height: $large-height
			grid-template-columns: 1fr $large-height

			&.force-height
				height: $large-height
				
				.label
					height: $large-height

				.icon
					height: $large-height

			.label
				font-size: 18px
				padding: 0 40px

				@media (max-width: 768px)
					font-size: 16px

			.icon
				min-height: $large-height
				width: $large-height
				font-size: 22px

		&.push-left
			margin-left: 15px

		&.push-right
			margin-right: 15px

		&.no-label
			grid-template-columns: 1fr

			.icon
				border-left: none
				border-right: none


		&.full-width
			width: 100%
	
		&.no-icon
			grid-template-columns: 1fr

</style>